import {
  getAssessories,
  AssessoriesDTO,
  AssessoriesFilters,
} from '../../api/assessories/getAssessories';
import { GenericState } from '../../types/apiModule';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import { Assessoria } from '../../types/assessories/assessoria.d';
import createApiModule from '../createApiModule';
import { PayloadAction } from '@reduxjs/toolkit';

export interface assessoriesModule extends GenericState<unknown> {
  data: AssessoriesDTO;
  filters: AssessoriesFilters;
}

const initialState: assessoriesModule = {
  errors: null,
  loading: false,
  data: {
    data: [] as Assessoria[],
    links: {} as LinksPage,
    meta: {} as PageInfo,
  },
  filters: {} as AssessoriesFilters,
};

const listAssessoriaModule = createApiModule({
  name: 'listAssessories',
  apiMethod: getAssessories,
  initialState,
  parse: (assessories) => assessories,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSuccess: () => {},
  onError: () => ({
    message: 'Error llistant les assessories',
  }),
  onValidationError: () => ({
    message: 'Error llistant les assessories',
  }),
  reducers: {
    setFilters(state, action: PayloadAction<AssessoriesFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {
  start: listAssessories,
  success: listAssessoriesOk,
  error: listAssessoriesKo,
  refresh: listAssessoriesRefresh,
  reset: listAssessoriesReset,
  setFilters,
} = listAssessoriaModule.slice.actions;

export default listAssessoriaModule;
